module.exports = __webpack_public_path__ + "img/82ne.4e9ed627.svg";